import HomePage from './themes/HomePageLight.css';
import HomeCard from './components/HomeCard/themes/HomeCardLight.css';
import GetHelp from './components/GetHelp/themes/GetHelpLight.css';
import HelpSearch from './components/HelpSearch/themes/HelpSearchLight.css';

export default {
  HomePage,
  HomeCard,
  GetHelp,
  HelpSearch
};
